module.exports = __webpack_public_path__ + "img/CEDIS-QUERETARO.45b491f9.png";